import { Divider, Button, Box, Link } from '@mui/material';
import React from 'react';
import NavLink from '../commons/NavLink';
import styles from './Header.module.css';

interface IProps {
  links: Array<{ link: string; label: string; action?: Function }>;
}

function HeaderTopMenu({ links }: IProps) {
  return (
    <Box sx={{ display: 'flex' }}>
      {links.map((link, index) => (
        <div key={link.label} className={styles.headerMenuItem}>
          {!link.action && (
            <Link
              key={link.label}
              to={link.link}
              component={NavLink}
              activeClassName={styles.active}
              className={styles.menuLink}
            >
              <Button size='small' className={styles.topMenuLink}>
                {link.label}
              </Button>
            </Link>
          )}
          {link.action && (
            <Button
              size='small'
              className={styles.topMenuLink}
              onClick={(e: React.MouseEvent) =>
                link.action ? link.action(e) : undefined
              }
            >
              {link.label}
            </Button>
          )}

          {index !== links.length - 1 && (
            <Divider
              key={'divider_' + link.label}
              orientation='vertical'
              variant='middle'
              flexItem
            />
          )}
        </div>
      ))}
    </Box>
  );
}

export default HeaderTopMenu;
